import { useRef } from "react";
import {
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogBody,
  AlertDialogFooter,
  Button,
  Text,
  useToast,
} from "@chakra-ui/react";
import { useDeleteVinculoMutation } from "../hooks/useDeleteVinculoMutation";

export default function DeleteVinculoDialog({ isOpen, onClose, vinculo }) {
  const cancelRef = useRef();
  const toast = useToast();
  const mutation = useDeleteVinculoMutation();

  const confirm = () => {
    if (!vinculo) return;
    mutation.mutate(vinculo.id, {
      onSuccess: () => {
        toast({ title: `Vínculo "${vinculo.nome}" excluído`, status: "success", duration: 4000 });
        onClose();
      },
      onError: (error) =>
        toast({
          title: "Não foi possível excluir o vínculo",
          description: error.response?.data?.mensagem,
          status: "error",
          duration: 5000,
          isClosable: true,
        }),
    });
  };

  return (
    <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose} isCentered>
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            Excluir vínculo
          </AlertDialogHeader>
          <AlertDialogBody>
            <Text>
              Tem certeza de que deseja excluir <strong>{vinculo?.nome}</strong>? Todos os plantões e comprovantes
              associados também serão apagados permanentemente. Esta ação não pode ser desfeita.
            </Text>
          </AlertDialogBody>
          <AlertDialogFooter gap={3}>
            <Button ref={cancelRef} variant="ghost" onClick={onClose} isDisabled={mutation.isPending}>
              Voltar
            </Button>
            <Button
              bg="danger.500"
              color="white"
              _hover={{ bg: "danger.600" }}
              onClick={confirm}
              isLoading={mutation.isPending}
            >
              Excluir vínculo
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
}
